
import logoSandos from './assets/img/sandos/logo.png';
import chainLogoSandos from './assets/img/sandos/chain-logo.png';
import logoFooterSandos from './assets/img/sandos/logo-footer.png';
import logoFooterDesktopSandos from './assets/img/sandos/logo-footer-desktop.png';
import logoCardSandos from './assets/img/sandos/logo-card.png';

import logoMarconfort from './assets/img/marconfort/logo.png';
import chainLogoMarconfort from './assets/img/marconfort/chain-logo.png';
import logoFooterMarconfort from './assets/img/marconfort/logo-footer.png';
import logoFooterDesktopMarconfort from './assets/img/marconfort/logo-footer-desktop.png';
import logoCardMarconfort from './assets/img/marconfort/logo-card.png';

const SANDOS = {
  cssVars: {
    '--main-color': '#005eb6',
    '--main-logo': `url(${logoSandos})`,
    '--main-logo-width': '115px',
    '--chain-logo': `url(${chainLogoSandos})`,
    '--logo-footer': `url(${logoFooterSandos})`,
    '--logo-footer-desktop': `url(${logoFooterDesktopSandos})`,
    '--logo-card': `url(${logoCardSandos})`,
  },
  constants: {
    chainSite: ['Sandos.com', { en: 'https://www.sandos.com', es: 'https://es.sandos.com' }],
    loyaltyName: 'Sandos4U',
  },
};

const MARCONFORT = {
  cssVars: {
    '--main-color': '#25547b',
    '--main-logo': `url(${logoMarconfort})`,
    '--main-logo-width': '75px',
    '--chain-logo': `url(${chainLogoMarconfort})`,
    '--logo-footer': `url(${logoFooterMarconfort})`,
    '--logo-footer-desktop': `url(${logoFooterDesktopMarconfort})`,
    '--logo-card': `url(${logoCardMarconfort})`,
  },
  constants: {
    chainSite: ['Marconfort.com', { en: 'https://www.marconfort.com', es: 'https://es.marconfort.com' }],
    loyaltyName: 'M4U',
  },
};

// Themes object, where the key is the brand id
export const THEMES = {
  1: SANDOS,
  3: MARCONFORT,
};
